const logos = [
  "Linxfour",
  "REM Capital AG",
  "Deutsche Leasing AG",
  "Hanseatische Leasing",
  "Sparkassen-Finanzgruppe",
  "Haspa",
  "DSGV",
  "Mittelstandsfinanzierung",
];

export default function TrustLogos() {
  const items = [...logos, ...logos];
  return (
    <section
      data-testid="trust-section"
      className="border-b border-black/10 py-12 md:py-16 bg-white"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 gap-3">
          <div className="overline">Partner & Stationen</div>
          <p className="text-sm text-[#4A4A52] max-w-md">
            Kooperations­partner Linxfour (Wien) und REM Capital AG
            (Stuttgart) sowie 30 Jahre Erfahrung in der
            Sparkassen-Finanzgruppe und im Leasing.
          </p>
        </div>
        <div className="marquee border-t border-b border-black/10 py-6">
          <div className="marquee-track">
            {items.map((name, i) => (
              <span
                key={i}
                className="font-display font-bold text-xl md:text-2xl tracking-tight text-[#0A0A0A]/70 uppercase"
              >
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
